var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAskHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.313,
    height: 20.316,
    viewBox: "0 0 25.313 20.316",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3125",
    "data-name": "Group 3125",
    transform: "translate(-11.272 -6.464)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M270.891,256.525l8.346,10.785-8.323-2.91",
    transform: "translate(-242.653 -240.53)",
    fill: "#efeeed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M240.435,253.575c-.087,5.054,5.509,9.283,12.5,9.447s12.725-3.8,12.812-8.852-5.509-9.282-12.5-9.448S240.52,248.522,240.435,253.575Z",
    transform: "translate(-229.162 -238.253)",
    fill: "#efeeed"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Q",
    transform: "translate(18.218 20.544)",
    fill: "#2168b2",
    fontSize: 14,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Q")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAskHover);
export default __webpack_public_path__ + "static/media/ask-hover.d60abc6fa2c25c44f6908bc49a4d3bc4.svg";
export { ForwardRef as ReactComponent };